"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildGA4ProductInteractionEvent = exports.buildGA4ProductItem = void 0;
const enums_1 = require("../enums");
const getVariant_1 = require("../helper/getVariant");
function buildGA4ProductItem({ product, position, itemListName, itemListType, appointment, isLocationSelected, }) {
    const [category, category2, category3, category4] = product.trackingPath;
    const getPriceCategory = () => {
        if (product.originalPrice) {
            return enums_1.GA4PriceCategory.Special;
        }
        if (product.hasFriendsDiscount) {
            return enums_1.GA4PriceCategory.FriendsDiscount;
        }
        return enums_1.GA4PriceCategory.Regular;
    };
    return {
        item_id: product.manufacturerSku,
        item_name: product.title,
        price: product.originalPrice?.gross?.amount ?? product.price.gross.amount,
        price_category: getPriceCategory(),
        price_special: product.originalPrice ? product.price.gross.amount : undefined,
        item_category: category,
        item_category2: category2,
        item_category3: category3,
        item_category4: category4,
        item_variant: (0, getVariant_1.getVariant)(appointment, product.productType),
        item_list_name: itemListName,
        item_list_type: itemListType,
        location_id: product.url,
        index: position,
        item_list_location_selected: isLocationSelected || false,
        item_location_count: isLocationSelected ? undefined : product.locationCount,
        item_list_location_distance: isLocationSelected
            ? product.closestLocationDistance
            : undefined,
        item_rating: product.rating?.value,
        item_rating_count: product.rating?.count,
        item_person_count: product.participants
            ? [product.participants.min, product.participants.max].join('-')
            : undefined,
        item_label_id: product.discountBadgeId,
        item_label_name: product.discountBadgeName,
        item_promotion_name: product.promotion,
    };
}
exports.buildGA4ProductItem = buildGA4ProductItem;
function buildGA4ProductInteractionEvent({ eventName, featureCategory, itemListName, itemListType, product, position, isLocationSelected, appointment, productTitle, }) {
    const eventData = {
        eventName,
        feature_category: featureCategory,
        product_title: productTitle,
        position,
    };
    if (itemListName) {
        eventData.item_list_name = itemListName;
        eventData.ecommerce = {
            items: [
                buildGA4ProductItem({
                    product,
                    position,
                    itemListName,
                    itemListType,
                    isLocationSelected,
                    appointment,
                }),
            ],
        };
    }
    return {
        eventData,
    };
}
exports.buildGA4ProductInteractionEvent = buildGA4ProductInteractionEvent;
//# sourceMappingURL=buildGA4ProductInteractionEvent.js.map